import React, { Component } from 'react';
import './App.css';
import MovieRow from './MovieRow';
import $ from 'jquery';

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {};
    // console.log("this is my initializer");

    //   const movies = [
    //     { id: 0, poster_src: "https://image.tmdb.org/t/p/w185_and_h278_bestv2/7WsyChQLEftFiDOVTGkv3hFpyyt.jpg", title: "Avengers: Infinity War", overview: "As the Avengers and their allies have continued to protect the world from threats too large for any one hero to handle"},
    //     { id: 1, poster_src: "https://image.tmdb.org/t/p/w185_and_h278_bestv2/2RDUQpzhJHVzObkL4ZxwJkbKYSz.jpg", title: "The Avengers", overview: "This is my second overview"}
    //   ]

    // var movieRows = [];
    // movies.forEach((movie) => {
    //   console.log(movie.title);
    //   const movieRow = <MovieRow movie={movie} />

    //   movieRows.push(movieRow);
    // })

    // this.state = {rows: movieRows}

    this.performSearch("ant man");
  }

  performSearch(searchTerm) {
    console.log("Perfrom Search using moviedb");
    const urlString =
      "https://api.themoviedb.org/3/search/movie?api_key=15c9fc4d5198a4193bcd517186b90798&query=" +
      searchTerm;
    $.ajax({
      url: urlString,
      success: searchResults => {
        console.log("Fetched data successfully");
        // console.log(searchResults);
        const results = searchResults.results;
        // console.log(results[0]);

        var movieRows = [];

        results.forEach(movie => {
          movie.poster_src =
            "https://image.tmdb.org/t/p/w185" + movie.poster_path;
          // console.log(movie.poster_path);
          const movieRow = <MovieRow key={movie.id} movie={movie} />;
          movieRows.push(movieRow);
        });

        this.setState({ rows: movieRows });
      },
      error: (xhr, status, err) => {
        console.error("failed to fetch data");
      }
    });
  }

  searchChangeHandler(event) {
    console.log(event.target.value);
    const boundObject = this;
    const searchTerm = event.target.value;
    boundObject.performSearch(searchTerm);
  }

  render() {
    return (
      <div>
        <table className="titleBar"><strong>
          <tbody>
            <tr>
              <td>
                <img alt="app icon" width="50" src="green_app_icon.png" />
              </td>
              <td width="8" />
              <td>
                <h1>MoviesDB Search</h1>
              </td>
            </tr>
          </tbody></strong>
        </table>

        <input
          type="search"
          style={{
            fontSize: 24,
            display: "inline",
            width: "20%",
            paddingTop: 8,
            paddingBottom: 8,
            paddingLeft: 16,
            marginBottom: 25,
            backgroundColor: '#efefef'
          }}
          onChange={this.searchChangeHandler.bind(this)}
          placeholder="Enter Search Term..."
          results="0"
        />
        <span className="fa fa-search form-control-feedback"></span>

        {this.state.rows}
      </div>
    );
  }
}

export default App;
